module.exports = __webpack_public_path__ + "static/media/expense.04e81665.png";